import { jsxs as d, jsx as a } from "react/jsx-runtime";
const t = ({ group: s, badge: n, badgeType: l = "muted", groupNavItem: e, className: r = "" }) => !s && !e ? null : /* @__PURE__ */ d("li", { className: "ListMenuHeader", children: [
  e || /* @__PURE__ */ a("span", { className: r, children: s }),
  n && /* @__PURE__ */ a("span", { className: `badge badge-${l}`, children: n })
] });
export {
  t as default
};
//# sourceMappingURL=ListMenuHeader.js.map
